import { render, staticRenderFns } from "./peservationInfo.vue?vue&type=template&id=330aeef2&scoped=true&"
import script from "./peservationInfo.vue?vue&type=script&lang=js&"
export * from "./peservationInfo.vue?vue&type=script&lang=js&"
import style0 from "./peservationInfo.vue?vue&type=style&index=0&id=330aeef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330aeef2",
  null
  
)

export default component.exports